import { log } from 'log';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getCleanPath } from 'js/utils/url.util';
import { path, prop } from 'js/utils/ramda.util';
import { useAppSelector } from 'js/store/hooks';
import { SPORTSBOOK_REDUCER } from 'js/store/constants';

import * as constants from '../constants';

export const useMountSportsbook = () => {
    const { pathname } = useLocation();
    const sportsbookRootURL = useAppSelector(prop('sportsbookRootURL'));
    const isAppInitialized = useSelector(path([SPORTSBOOK_REDUCER, 'isAppInitialized']));
    const sportPageRegExp = new RegExp(`(^${sportsbookRootURL}$)|(^${sportsbookRootURL}/)`);
    const isSportPage = sportPageRegExp.test(getCleanPath(pathname));

    useEffect(() => {
        if (isAppInitialized && isSportPage) {
            try {
                window.Sportsbook?.mountSportsbook(constants.CONTAINER_ID);
            } catch (error) {
                log('log', '[SPORTSBOOK | Portal] Mount sportsbook app error', error);
            }
        }
    }, [isAppInitialized, isSportPage]);
};
